import { action } from 'typesafe-actions';

import { publicStoreTypes } from './types';

// ticketData
export const setTicketDataRequest = (payload: object) =>
  action(publicStoreTypes.SET_TO_PAY_DATA, payload);

// step
export const setStep = (payload: object) =>
  action(publicStoreTypes.SET_STEP, payload);

// reschduleData
export const setReschduleData = (payload: object) =>
  action(publicStoreTypes.SET_RESCHEDULE_DATA, payload);

// isCreateProfile
export const setIsCreateProfile = (payload: boolean) =>
  action(publicStoreTypes.SET_IS_CREATE_PROFILE, payload);

// auth
export const ticketSalesLoginRequest = (payload?: {
  email: string;
  password: string;
}) => action(publicStoreTypes.TICKET_SALES_LOGIN_REQUEST, payload);
export const ticketSalesLoginSuccess = () =>
  action(publicStoreTypes.TICKET_SALES_LOGIN_SUCCESS);
export const ticketSalesLoginFailure = (payload: {
  key: string;
  message: string;
}) => action(publicStoreTypes.TICKET_SALES_LOGIN_FAILURE, payload);
